import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

const withContainer = Component => () => {
  const { openNotification } = hooks.useNotification()
  const navigate = hooks.useNavigate()

  const [upload] = hooks.useModelFunction('list', 'import')

  const onRowClick = useCallback((row) => {
    navigate(`/list/${row?.original?.list_id}`)
  }, [navigate])

  const mergedProps = {
    onRowClick,
    upload,
    navigate,
    openNotification
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
